import { HttpClient, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable, EMPTY, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ToasterService } from './toast.service';

@Injectable()
export class GenericService<T> {
	constructor(protected http1: HttpClient) {}
	private toasterService1: ToasterService = inject(ToasterService);

	private handleError(error: HttpErrorResponse) {
		if (error.status === 0) {
			console.warn('Server unreachable or offline.');
			this.toasterService1.showError('server_unreachable', { unique: true, autoClose: false, closeButton: false });
			return EMPTY;
		}
		return throwError(() => error);
	}

	getAll(request: { params?: any; endpoint: string }): Observable<T[]> {
		return this.http1.get<T[]>(`${environment.api}/${request.endpoint}`, { params: request.params }).pipe(catchError((err) => this.handleError(err)));
	}

	getById(request: { params?: any; id: number | string; endpoint: string }): Observable<T> {
		return this.http1.get<T>(`${environment.api}/${request.endpoint}/${request.id}`, { params: request.params }).pipe(catchError((err) => this.handleError(err)));
	}

	post(request: { data?: T; params?: any; endpoint: string }): Observable<any> {
		return this.http1.post<any>(`${environment.api}/${request.endpoint}`, request.data, { params: request.params }).pipe(catchError((err) => this.handleError(err)));
	}

	update(request: { id: number | string; data?: T; endpoint: string }): Observable<T> {
		return this.http1.put<T>(`${environment.api}/${request.endpoint}/${request.id}`, request.data).pipe(catchError((err) => this.handleError(err)));
	}

	delete(request: { id: number | string; endpoint: string }): Observable<void> {
		return this.http1.delete<void>(`${environment.api}/${request.endpoint}/${request.id}`).pipe(catchError((err) => this.handleError(err)));
	}
}
